import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-grid-system";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { UpdateProduct, updateProductFields } from "../../../server/Product";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input, { Select } from "../../containers/InputForm";
import ProductEditPerloed from "./productEditPerloed";
import { LinkedProducts, LinkedProductsRemove } from "../../../server/LinkedProducts";

const schema = yup
  .object({
    ProductName: yup.string().required("שם המוצר חובה"),
    Barcode: yup
      .string()
      .required("חובה להכניס ברקוד")
      .test("len", (x) => x.length >= 5 && x.length <= 15),
    Description: yup.string().max(35, "תיאור חייב להיות עד 35 תווים"),
    WeightQuantity: yup.number("").positive(),
  })
  .required();

const ProductEditForm = () => {
  const [catsOptions, setCatsOptions] = useState([]);
  const [alterProds, setAlterProds] = useState([]);
  const [parallelProds, setParallelProds] = useState([]);
  const [families, setFamilies] = useState([]);
  const [parentCategory, setParentCategory] = useState(null);

  const {
    filterList,
    categoriesState,
    product,
    products,
    stationId,
    productCategories,
    items,
    parameters: { p_view_out_of_stock, p_unit_measure, p_disable, p_box_type },
  } = useSelector((state) => ({
    filterList: state.displayProduct.filterList,
    categoriesState: state.category.categories,
    product: state.selectedProduct.product,
    products: state.selectedProduct.products,
    parameters: state.parameters,
    stationId: state.user.stationId,
    productCategories: state.selectedProduct.productCategories,
    items: state.displayProduct.itemsShow,
  }));

  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: { ...product },
    resolver: yupResolver(schema),
  });

  const kashrutTypeOptions = [
    { Id: "חלבי", Name: "חלבי" },
    { Id: "בשרי", Name: "בשרי" },
    { Id: "פרווה", Name: "פרווה" },
    { Id: "לא מוגדר", Name: "לא מוגדר" },
  ];

  const kashrutFeatureOptions = [
    { Id: "כשרות לימות השנה", Name: "כשרות לימות השנה" },
    { Id: "כשר לפסח", Name: "כשר לפסח" },
    { Id: "כשר לפסח לאוכלי קטניות", Name: "כשר לפסח לאוכלי קטניות" },
    { Id: "כשרות", Name: "כשרות" },
    { Id: "מאושר", Name: "מאושר" },
    { Id: "מאושר לפסח", Name: "מאושר לפסח" },
    { Id: "נאפה לאחר הפסח", Name: "נאפה לאחר הפסח" },
    { Id: "נטחן ונאפה לאחר פסח", Name: "נטחן ונאפה לאחר פסח" },
    { Id: "מקמח שנטחן לאחר פסח", Name: "מקמח שנטחן לאחר פסח" },
    { Id: "-", Name: "-" },
  ];

  const unitOfMeasureOptions = [
    { Id: "גרם", Name: "גרם" },
    { Id: "יחידה", Name: "יחידה" },
    { Id: "יחידות", Name: "יחידות" },
    { Id: "ליטר", Name: "ליטר" },
    { Id: 'מ"ל', Name: 'מ"ל' },
    { Id: "מטר", Name: "מטר" },
    { Id: 'ק"ג', Name: 'ק"ג' },
  ];

  const statusOptions = [
    { Id: "VALID", Name: "תקין" },
    { Id: "INVALID", Name: "לא תקין" },
  ];


  useEffect(() => {
    reset(product);
  }, [product]);

  const selectProductLink = (currProd, chosenProd, action) => {
    const val = {
      ProductMkt: currProd,
      SubProductMkt: chosenProd,
      TypeLinked: action,
    };
    LinkedProducts(val)
      .then(() => {
        const match = products.find((prods) => prods.Mkt === chosenProd);
        switch (action) {
          case "1":
            const alterProdsEdit = [...alterProds];
            alterProdsEdit.push(match);
            setAlterProds(alterProdsEdit);
            break;
          case "2":
            const parallelProdsEdit = [...parallelProds];
            parallelProdsEdit.push(match);
            setParallelProds(parallelProdsEdit);
            break;
          default:
            break;
        }
      })
      .catch(() => console.log("error"));
  };

  const removeLinkage = (ProductMkt, SubProductMkt, TypeLinked) => {
    const val = {
      TypeLinked,
      ProductMkt,
      SubProductMkt,
    };
    LinkedProductsRemove(val)
      .then(() => {
        if (TypeLinked === "1") {
          const alterProds = alterProds.filter((item) => {
            return item.ProductMkt !== ProductMkt;
          });
          setAlterProds(alterProds);
        } else if (TypeLinked === "2") {
          const parallelProds = parallelProds.filter((item) => {
            return item.ProductMkt !== ProductMkt;
          });
          setParallelProds(parallelProds);
        }
      })
      .catch(() => console.log("error"));
  };

  const tryUpdate = ({ target: { id, value } }) => {
    handleSubmit();
    if (!errors[id]) {
      updateProductFields(stationId, product.productId, { [id]: value });
    }
  };


  useEffect(() => {
    if (productCategories.length > 0)
      setParentCategory(productCategories[0].slug)
  }, productCategories)

  useEffect(() => {
    if (categoriesState.length > 0 && productCategories.length > 0) {
      const newCatsOptions = [];
      newCatsOptions.push(categoriesState);
      [...productCategories].reverse().map((cat, index) => {
        setValue(`catLevel${index + 1}`, cat.slug);
        newCatsOptions.push(newCatsOptions.at(-1).find((category) => category.slug === cat.slug).children);
      });
      setValue(`catLevel${productCategories.length+1}`, null)
      setCatsOptions(newCatsOptions);
    }
  }, [productCategories, categoriesState]);

  const tryUpdateCategory = ({ target: { id, value } }) => {
    handleSubmit();
    if (!errors[id]) {
      updateProductFields(stationId, product.productId, {fromSlug: parentCategory, toSlug: value}).then(res => {
        setParentCategory(value);
        const level = parseInt(id.split("catLevel")[1])
        const newCatsOptions = [...catsOptions.slice(0, level)];
        newCatsOptions[level] = newCatsOptions[level-1].find(cat => cat.slug === value).children
        setCatsOptions(newCatsOptions);
        setValue(`catLevel${level + 1}`, null);
    }).catch(e => console.log("error", e));
  }
  };


  return (
    <form className="product-details-edit">
      <Container>
        <Row>
          <InputCol
            sm={4}
            name="name"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="textarea"
            label="שם המוצר"
          />
          <InputCol
            sm={2}
            name="gtin"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            label="ברקוד"
            type="text"
          />
          <InputCol
            sm={2}
            name="SubMkt"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="מקט יצרן"
          />
          <SelectCol
            sm={2}
            name="status"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={statusOptions}
            label="סטטוס"
          />
        </Row>

        <Row>
          <InputCol
            sm={4}
            name="description"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="textarea"
            label="תיאור קצר"
          />
          <SelectCol
            sm={4}
            name="kosherSupervision[0].supervisionAgency"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={filterList[1]?.Items}
            label="כשרות"
          />
          {catsOptions[0] && (
            <SelectCol
              sm={4}
              name="catLevel1"
              errors={errors}
              register={register}
              onChange={tryUpdateCategory}
              options={catsOptions[0]}
              label="מחלקה"
            />
          )}
        </Row>

        <Row>
          <InputCol
            sm={2}
            name="weightDetails.netContent"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="משקל"
          />
          <SelectCol
            sm={2}
            name="weightDetails.unitOfMeasure"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={unitOfMeasureOptions}
            label="יח׳ משקל"
          />
          <SelectCol
            sm={4}
            name="kosherSupervision[0].kashrutFeature"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={kashrutFeatureOptions}
            label="סוג כשרות"
          />
          {catsOptions[1]?.length && (
            <SelectCol
              sm={4}
              name="catLevel2"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[1]}
              label="קבוצה"
            />
          )}
        </Row>

        <Row>
          <InputCol
            sm={2}
            name="weightJump"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="קפיצת משקל"
          />
          <InputCol
            sm={2}
            name="weightDetails.grossWeight"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="סטיית משקל ברוטו"
          />
          <SelectCol
            sm={4}
            name="kosherSupervision[0].classification"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={kashrutTypeOptions}
            label="חלבי / בשרי"
          />
          {catsOptions[2]?.length > 0 && (
            <SelectCol
              sm={4}
              name="catLevel3"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[2]}
              label="תת קבוצה"
            />
          )}
        </Row>

        <Row>
          <Col sm={4}>
            <ProductEditPerloed
              label="מוצר מקביל"
              arrShow={parallelProds}
              onSelectProduct={(value) =>
                selectProductLink(product.Mkt, value, "2")
              }
              products={products}
              removeLinkage={(value) => removeLinkage(product.Mkt, value, "2")}
            />
          </Col>

          <SelectCol
            sm={4}
            name="brandName"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={filterList[0]?.Items}
            label="מותג"
          />
          {catsOptions[3]?.length > 0 && (
            <SelectCol
              sm={4}
              name="catLevel4"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[3]}
              label="מקבץ"
            />
          )}
        </Row>

        <Row>
          <Col sm={4}>
            <ProductEditPerloed
              label="מוצר חלופי"
              arrShow={alterProds}
              onSelectProduct={(value) =>
                selectProductLink(product.Mkt, value, "1")
              }
              products={products}
              removeLinkage={(value) => removeLinkage(product.Mkt, value, "1")}
            />
          </Col>

          <InputCol
            sm={2}
            name="PackageQuantity"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="כמות למארז"
          />
          <SelectCol
            sm={2}
            name="ViewOutOfStockId"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={p_view_out_of_stock}
            label="סימון חוסר במלאי"
          />
        </Row>

        <div className="check-box">
          <div className="checkbox-style">
            <Input
              name="vatExempt"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label='פטור מע"מ'
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="SupervisedPrice"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="בפיקוח"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="weightDetails.weighedProduct"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="מוצר שקיל"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="DepositProduct"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="פריט פקדון"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="ShowExpired"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="ניהול תוקף"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="ShowExpired"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="הצג תוקף"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="viewBrand"
              errors={errors}
              onBlur={tryUpdate}
              register={register}
              type="checkBox"
              label="הצג מותג"
            />
          </div>
        </div>
        {/* {product.Category.length && product.Category[product.Category.length-1].isFamily && <> <p>כל המוצרים במקבץ זה:</p> <ul> {items.map((prod) => { return <li key={prod.Mkt}><a href={`/edit-product/${prod.Mkt}`}>{prod.ProductName}</a></li>; })}</ul></>} */}
      </Container>
    </form>
  );
};

const InputCol = ({ name, errors, label, type, register, sm, onBlur }) => {
  return (
    <Col sm={sm}>
      <Input
        name={name}
        errors={errors}
        onBlur={onBlur}
        register={register}
        label={label}
        type={type}
      />
    </Col>
  );
};

const SelectCol = ({
  name,
  errors,
  label,
  register,
  sm,
  options,
  onChange,
}) => {
  return (
    <Col sm={sm}>
      <Select
        name={name}
        errors={errors}
        {...register(name)}
        options={options}
        label={label}
        onChange={onChange}
      />
    </Col>
  );
};

export default ProductEditForm;
